import React from "react";
import "./Results.css";
const Results = (props) => {
  
  return <div className="results">{props.children}</div>;
};

export default Results;
